import axios from 'axios'
import './common'

export default {
    getList: (params) => axios.get(`/surveys`, { params: params }),
    get: (id) => axios.get(`/surveys/${id}`),
    create: (data) => axios.post(`/surveys`, data),
    update: (id, data) => axios.put(`/surveys/${id}`, data),
    updateAsForm(id, data) {
        data.append("_METHOD", "PUT");
        return axios.post(`/surveys/${id}`, data);
    },
    delete: (id) => axios.delete(`/surveys/${id}`),
    enable: (id) => axios.patch(`/surveys/${id}/enable`),
    disable: (id) => axios.patch(`/surveys/${id}/disable`),
    updateForm: (id, data) => axios.put(`/surveys/${id}/form`, data),
    submit: (id, data) => axios.post(`/surveys/${id}/submit`, data),
    submittable: (id) => axios.get(`/surveys/${id}/submittable`),
    editEnd: (id, data) => axios.patch(`/surveys/${id}/edit-end`, data),
    answers: (id) => axios.get(`/surveys/${id}/answers`),
    export: (id) => axios.get(`/surveys/${id}/export`, { responseType: "blob" }),
    nbTargets: (id) => axios.get(`/surveys/${id}/nb-targets`),
    createPage: (survey_id, data) => axios.post(`/surveys/${survey_id}/pages`, data),
    updatePage: (survey_id, id, data) => axios.put(`/surveys/${survey_id}/pages/${id}`, data),
    deletePage: (survey_id, id) => axios.delete(`/surveys/${survey_id}/pages/${id}`),
    createQuestion: (survey_id, data) => axios.post(`/surveys/${survey_id}/questions`, data),
    updateQuestion: (survey_id, id, data) => axios.put(`/surveys/${survey_id}/questions/${id}`, data),
    deleteQuestion: (survey_id, id) => axios.delete(`/surveys/${survey_id}/questions/${id}`),
    createOption: (survey_id, question_id, data) => axios.post(`/surveys/${survey_id}/questions/${question_id}/options`, data),
    updateOption: (survey_id, question_id, id, data) => axios.put(`/surveys/${survey_id}/questions/${question_id}/options/${id}`, data),
    deleteOption: (survey_id, question_id, id) => axios.delete(`/surveys/${survey_id}/questions/${question_id}/options/${id}`),
}